module.exports = __webpack_public_path__ + "img/bag-check.59c920a9.svg";